import React from "react";

function ReadOnlyField({ label, value }) {
  return (
    <div className="mb-2">
      <label className="form-label small text-muted mb-1">{label}</label>
      <input type="text" className="form-control" value={value || ""} readOnly />
    </div>
  );
}

function onlyDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

function formatPhone(value) {
  const digits = onlyDigits(value);

  if (digits.length === 11) {
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }

  if (digits.length === 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }

  return value || "";
}

export default function VehicleInfo({ vehicle }) {
  if (!vehicle) return null;

  return (
    <div className="card mb-3">
      <div className="card-header">
        <strong>Dados do Veiculo</strong>
      </div>
      <div className="card-body">
        <div className="row g-3">
          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Marca" value={vehicle.brand} />
          </div>
          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Modelo" value={vehicle.model} />
          </div>
          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Placa" value={vehicle.plate} />
          </div>
          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Ano" value={vehicle.year} />
          </div>

          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Cor" value={vehicle.color} />
          </div>
          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Equipamento" value={vehicle.equipment} />
          </div>
          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Serial" value={vehicle.serial} />
          </div>
          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Operadora" value={vehicle.carrier} />
          </div>

          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Numero da linha" value={formatPhone(vehicle.lineNumber)} />
          </div>
          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Bateria Principal" value={vehicle.mainBattery} />
          </div>
          <div className="col-lg-4 col-md-6">
            <ReadOnlyField label="Bateria Backup" value={vehicle.backupBattery} />
          </div>
        </div>
      </div>
    </div>
  );
}
